import { CloseOutlined } from '@ant-design/icons'
import { ScreenModel } from '@hmedia/legenda-ds-api-client'
import { Modal, message } from 'antd'
import { FC } from 'react'
import { useUpdateCustomContentPermissionMutation } from './queries'
import { useRemoveCustomContentFromScreenMutation } from '../customcontent/queries'
import API from '../../services/DSApiService'

type Props = {
  visible: boolean
  screen?: ScreenModel
  onClose: () => void
  onSuccess: () => void
}

export const CustomContentPermissionModal: FC<Props> = ({ visible, screen, onClose, onSuccess }) => {
  const currentStatus = screen?.customContentEnabled ?? true
  const newStatus = !currentStatus

  const updatePermissionMutation = useUpdateCustomContentPermissionMutation(
    () => {
      message.success('Egyedi tartalom engedélyezés státusz frissítve')
      onSuccess()
    },
    (error) => {
      message.error('Hiba történt az engedélyezés státusz frissítésénél')
      console.error(error)
    }
  )

  const removeCustomContentMutation = useRemoveCustomContentFromScreenMutation(
    () => {
      // Silent success - handled by permission update
    },
    (error) => {
      console.error('Error removing custom content:', error)
    }
  )

  const handleSave = async () => {
    if (!screen) return

    // If we're disabling custom content permission, first remove any existing custom content assignments
    if (!newStatus) {
      try {
        const checkResponse = await API.checkScreenHasCustomContentAssignment(screen.id)
        if (checkResponse.data.hasAssignment && checkResponse.data.currentAssignment) {
          // Remove the custom content assignment
          removeCustomContentMutation.mutate({
            screenId: screen.id,
            request: { customContentId: checkResponse.data.currentAssignment.customContentId },
          })
        }
      } catch (error) {
        console.error('Error checking/removing custom content assignment:', error)
        // Continue with permission update even if removal fails
      }
    }

    updatePermissionMutation.mutate({
      screenId: screen.id,
      enabled: newStatus,
    })
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      title={`Egyedi tartalom engedélyezése a kijelzőre - ${screen?.name}`}
      open={visible}
      onCancel={handleClose}
      onOk={handleSave}
      okText={currentStatus ? 'Igen, tiltsa le' : 'Igen, engedélyezze'}
      cancelText="Mégse"
      confirmLoading={updatePermissionMutation.isLoading}
      closeIcon={<CloseOutlined />}
      maskClosable={false}
    >
      <div style={{ marginBottom: '16px' }}>
        <p>Jelenlegi státusz: <strong>{currentStatus ? 'Engedélyezve' : 'Tiltva'}</strong></p>
        <p>Új státusz: <strong>{newStatus ? 'Engedélyezve' : 'Tiltva'}</strong></p>
      </div>
      
      <div style={{
        padding: '12px',
        backgroundColor: '#f0f0f0',
        borderRadius: '6px',
        marginTop: '16px'
      }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
          Biztosan {newStatus ? 'engedélyezni szeretné' :'le szeretné tiltani'} az egyedi tartalom megjelenítését ezen a kijelzőn?
        </p>
      </div>
    </Modal>
  )
}

export default CustomContentPermissionModal